import { PropTypes } from 'prop-types';

const FIELDS_NAMES = {
  zipcode: 'zipcode',
  company_name: 'company_name',
  address_line: 'address_line',
  contact_name: 'contact_name',
  contact_phone: 'contact_phone',
  city: 'city',
  country: 'country',
};

const ADDRESS_BY_STOP = {
  pickup: 'address_from',
  dropoff: 'address_to',
};

const POI_ADDRESS_CONSTANTS = {
  venue_type: 'venue',
  address_type: 'address',
  geometry_point_type: 'Point',
};

const PROP_TYPES = {
  address: PropTypes.shape({
    zipcode: PropTypes.string,
    company_name: PropTypes.string,
    address_line: PropTypes.string,
    contact_name: PropTypes.string,
    contact_phone: PropTypes.string,
  }),
  address_suggestion: PropTypes.shape({
    zipcode: PropTypes.string,
    company_name: PropTypes.string,
    address_line: PropTypes.string,
    contact_name: PropTypes.string,
    contact_phone: PropTypes.string,
  }),
};

/* The address parser service returns several parameters that need to be mapped
 * to the Pelias-based equivalent parameters. This map specifies the equivalence,
 * and the order in which they apply if they correspond to the same param.
 */
const POI_PARSER_PARAMS_TO_PELIAS_PARAMS = {
  road: 'address',
  street: 'address',
  house_number: 'address',
  city: 'locality',
  postcode: 'postalcode',
  state: 'country',
  neighbourhood: 'neighbourhood',
};

const ADDRESS_FIELDS_ORDER_IN_ORDER = ['road', 'street', 'house_number'];

const DEBOUNCE_SEARCH_INTERVAL = 1000;

export default {
  FIELDS_NAMES,
  ADDRESS_BY_STOP,
  POI_ADDRESS_CONSTANTS,
  PROP_TYPES,
  POI_PARSER_PARAMS_TO_PELIAS_PARAMS,
  ADDRESS_FIELDS_ORDER_IN_ORDER,
  DEBOUNCE_SEARCH_INTERVAL,
};
